module.exports = __webpack_public_path__ + "static/img/就诊预约入口-英@2x.98ff447.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/gjyxb/assets/en/就诊预约入口-英@2x.png
// module id = 1489
// module chunks = 363